<div class="container pb-4 pt-4 ">
  <app-breadcrumb currentRouteName="Contrats"></app-breadcrumb>
  <h1 class="pt-4">Contrats</h1>
  <div class="mt-2 mb-3 alert alert-info pt-3 pb-3 d-inline-block">
    <fa-icon icon="info-circle"></fa-icon>
    Ce tableau liste l'ensemble des contrats de votre structure. Pour la gestion des utilisateurs, rendez-vous sur la
    page <a class="text-decoration-underline" routerLink="/utilisateurs">Utilisateurs</a>
  </div>

  <ls-dynamic-table [data]="contracts | sortByProductName" [headers]="tableHeaders" currentSort="''">
    <ng-template let-item>
      @let cat = getCategoryFromProduct(item.product);
      <th scope="row" class="d-inline d-md-none pt-2 pb-2">
        <app-badge class="me-1 ms-1"
                   [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"></app-badge>
      </th>
      <td class="d-none d-md-table-cell">
        <app-badge class="me-1 ms-1"
                   [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"></app-badge>
      </td>
      <td class="d-none d-md-table-cell">
        {{ statusToStr(item) }}
      </td>
      <td>
        @if(item.dp; as dp) {
          <span>
             <span class="fw-bold d-block d-md-none">Contact direction de projet :</span>
            {{ dp.firstname }} {{ dp.lastname }} /
            <a href="mailto:{{dp.email}}" class="text-primary cursor-pointer icon-hover">{{ dp.email }}</a>
             <fa-icon class="d-none d-md-inline-block ms-2 text-info cursor-pointer" icon="copy"
                      ngbTooltip="Copier l'adresse mail dans le presse-papier" appCopy [text]="dp.email"/>
          </span>
        } @else {
          <span class="fst-italic text-light-grey">
            Aucun contact de direction de projet
          </span>
        }
      </td>
      <td class="text-center d-none d-md-table-cell">
        @if(item.status !== 'Not Started' &&  item.status !== 'Non démarré') {
          <a href="javascript:void(0)" class="text-info cursor-pointer" placement="start" [ngbPopover]="popContent"
             popoverTitle="Utilisateurs associés">
            <fa-icon icon="eye" size="lg"></fa-icon>
            Voir la liste
          </a>
          <ng-template #popContent>
            <app-contract-associated-users [contract]="item" [contacts]="contacts"/>
          </ng-template>
        }
      </td>
      <td class="d-inline d-md-none">
        @if(item.status !== 'Not Started') {
          <span class="fw-bold">Utilisateurs associés</span>
          <app-contract-associated-users [contract]="item" [contacts]="contacts"/>
        }
      </td>
    </ng-template>
  </ls-dynamic-table>
</div>
